import React from 'react';
import HmiReadAndWrite from './HmiReadAndWrite';
import HmiDataPlug from './HmiDataPlug';
import HmiPanelToolAnalysis from './HmiPanelToolAnalysis';
import HmiDataDebit from './HmiDataDebit';
import HmiPurposeAndDurationOfDataUsage from './HmiPurposeAndDurationOfDataUsage';
import HmiRating from './HmiRating';
import HmiActions from './HmiActions';
import HmiHeader from './HmiHeader';

const HmiAdapter: React.FC = () => {
  return (
    <>
      <HmiHeader />
      <HmiReadAndWrite />
      <HmiPanelToolAnalysis />
      <HmiDataPlug />
      <HmiDataDebit />
      <HmiPurposeAndDurationOfDataUsage />
      <HmiRating />
      <HmiActions />
    </>
  );
};

export default HmiAdapter;
